import type { FC, ReactNode, KeyboardEvent } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Grid, Paper, type SxProps, type Theme, Typography, useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { routes } from "@/router/Routes";
import Logo from "@/theme/logos/relux.svg?react";
import Languages from "@/components/Languages";
import getStyles from "./styles";

type Props = {
  title?: string;
  subtitle?: string | ReactNode;
  showHeader?: boolean;
  showLanguages?: boolean;
  sx?: SxProps<Theme>;
  children: ReactNode;
  onKeyDown?: (event: KeyboardEvent<HTMLDivElement>) => void;
};

export const Page: FC<Props> = ({ title, subtitle = null, showHeader = true, showLanguages = false, sx = {}, children, onKeyDown = () => {} }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const styles = getStyles(theme);

  return (
    <Grid width={480} sx={{ ...styles.page, ...sx }}>
      <Paper elevation={3} sx={styles.paper} onKeyDown={onKeyDown}>
        {showLanguages && <Languages />}
        {showHeader && (
          <Grid container alignItems="flex-start" justifyContent="space-between">
            <Box display="flex" flexDirection="row" alignItems="center" justifyContent="space-between" width="100%" mb="1rem">
              {title && <Typography variant={isMobile ? "h3" : "h2"}>{t(title)}</Typography>}
              <Link
                to={routes.pages.login}
                style={{
                  position: "relative",
                  display: "inline-flex",
                  alignItems: "center",
                }}
              >
                <Logo height={24} />
                {/* <Typography sx={styles.logoText}>Authentication</Typography> */}
              </Link>
            </Box>
            {!!subtitle && <Box mb="1rem">{typeof subtitle === "string" ? t(subtitle) : subtitle}</Box>}
          </Grid>
        )}
        {children}
      </Paper>
    </Grid>
  );
};

export default Page;
